import React from 'react';
import PropTypes from 'prop-types';

function Header({ prompt, button }) {
  return (
    <div>
      <div style={{ display: 'inline-block', marginBottom: '1rem' }}>
        {prompt}
      </div>
      <div style={{ display: 'inline-block', marginLeft: '2rem' }}>
        {button}
      </div>
    </div>
  );
}

Header.propTypes = {
  prompt: PropTypes.string,
  button: PropTypes.node,
};

export default Header;
